import { StyleSheet } from 'react-native';

export const ICON_SIZE = {
    width: 34,
    height: 34,
};

const styles = StyleSheet.create({
    container: {
        // @ts-ignore
        position: 'fixed',
        left: 15,
        height: 68,
        width: ICON_SIZE.width,
        justifyContent: 'center',
    },
});

export default styles;
